module.exports = __webpack_public_path__ + "media/images/icons/skills-development-5b929532f36222bd2e4ed0f191216557.svg";